import React from 'react'

export function Loading({className = '', label = 'Carregando...'}:{className?:string, label?:string}){
    return <div className={`text-muted ${className}`}><i className="fa fa-spin fa-circle-notch"></i> {label}</div>
}